import { Outlet } from "react-router-dom";

const DevLogin = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default DevLogin;
